
import { Component, Input, OnInit } from '@angular/core';
import { HelpFlyoutService } from '@app/administration/catalog/catalog-state/help-trigger/help-flyout.service';
import { NgbTooltip } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { ITitleHelpWrapper } from '@interfaces/iTile';

@Component({
	selector: 'app-help-tile',
	templateUrl: './help-tile.component.html',
	styleUrls: ['./help-tile.component.scss'],
	imports: [NgbTooltip, TranslatePipe]
})
export class HelpTileComponent implements OnInit {
	@Input() help: ITitleHelpWrapper;
	constructor(
		public helpFlyoutService: HelpFlyoutService
	) { }

	ngOnInit(): void {
	}

	openHelp() {
		if (this.help.helpId) {
			this.helpFlyoutService.setHelpId(this.help.helpId);
		}
		this.helpFlyoutService.open();
	}
}
